import React, { useState,useEffect } from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'
import CalendarViewComponent from '../components/CalendarViewComponent'
import calendarServices from '../calendarServices';
import CalenderEventForm from '../components/CalenderEventForm';
import EventListView from '../components/EventListView';
import { useAppData } from '../../../../../context/AppDataContext';

function CalendarDashboardPage() {

    const {getCalendarEventList} = useAppData()


    return (
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-12'> 
                        <span className='float-end'><CalenderEventForm callBack={getCalendarEventList} /></span>
                    </div>
                    
                    <div className='col-md-6'>
                        <EventListView  />
                    </div>
                    <div className='col-md-6'>
                        <CalendarViewComponent />
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default CalendarDashboardPage